export default __webpack_public_path__ + "static/media/ductBankCover.5afdd93a.jpg";